import React from "react";
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Divider,
  Avatar,
  Tooltip,
} from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import Tool, {
  CalculatorTool,
  CrawlTool,
  CsvTool,
  PostgresTool,
  SQLTool,
} from "../../../Types/Tool";
import {
  capitalizeFirstLetter,
  formatDate,
} from "../../../utils/Common/Common";
import ProImg1 from "../../../../assets/images/toolsIcon.svg";
import calendarIcon from "../../../../assets/images/calendarIcon.svg";
import CustomToolIcon from "../../../../assets/images/toolsIcon.svg";

interface MyComponentProps {
  data: CalculatorTool | CrawlTool | PostgresTool | SQLTool | CsvTool;
  deleteFun: (row: Tool) => void;
  editFun: (row: Tool) => void;
}

const ToolCard: React.FC<MyComponentProps> = (props) => {
  return (
    <Card
      sx={{
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
        backdropFilter: "blur(5px)",
        backgroundColor: "rgba(256, 256, 256, 0.7)",
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar
            src={ProImg1}
            sx={{
              backgroundColor: "#01AEEE",
              "& img": {
                objectFit: "none",
              },
            }}
          />
          {props.data.name.length > 38 ? (
            <Tooltip title={props.data.name || ""} placement="top-start">
              <Typography
                variant="subtitle1"
                fontWeight={500}
                noWrap
                sx={{
                  maxWidth: 250,
                  lineHeight: "20px",
                  textTransform: "capitalize",
                }}
              >
                {props.data.name || ""}
              </Typography>
            </Tooltip>
          ) : (
            <Typography
              variant="subtitle1"
              fontWeight={500}
              noWrap
              sx={{
                maxWidth: 250,
                lineHeight: "20px",
                textTransform: "capitalize",
              }}
            >
              {props.data.name || ""}
            </Typography>
          )}
        </Box>
        {props.data.description.length > 52 ? (
          <Tooltip title={props.data.description || ""} placement="top-start">
            <Typography
            variant="body1"
            color="text.secondary"
            mt={1}
            sx={{
              display: "-webkit-box",
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
              minHeight: "22px",
            }}
          >
            {props.data.description || ""}
          </Typography>
          </Tooltip>
        ) : (
          <Typography
            variant="body1"
            color="text.secondary"
            mt={1}
            sx={{
              display: "-webkit-box",
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
              minHeight: "22px",
            }}
          >
            {props.data.description || ""}
          </Typography>
        )}
        <Box display="flex" alignItems="center" gap={1} mt={1}>
          <Box display="flex">
            <img src={calendarIcon} />
          </Box>
          <Typography variant="body2" sx={{ color: "#6E6E6E" }}>
            {props.data.created_at ? formatDate(props.data.created_at) : ""}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" gap={1} mt={1}>
          <Typography variant="body2" color="text.secondary">
            Type:
          </Typography>
          <Box>
            <Typography
              component="span"
              sx={{
                backgroundColor: "#f5f7fa",
                color: "#6E6E6E",
                borderRadius: "16px",
                px: 1.5,
                py: 0.5,
                fontSize: "12px",
                fontWeight: 400,
                display: "inline-block",
              }}
            >
              {capitalizeFirstLetter(props.data.config.toolkit_type || "")}
            </Typography>
          </Box>
        </Box>
      </CardContent>
      <Divider />
      <Box sx={{ display: "flex", justifyContent: "space-between", p: 1.5 }}>
        <Box display="flex" alignItems="center" gap={0.5}>
          <Box
            sx={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: props.data.is_active ? "#04db93" : "error.main",
            }}
          ></Box>
          <Typography
            variant="caption"
            color={props.data.is_active ? "#04db93" : "error"}
          >
            {props.data.is_active ? "Active" : "InActive"}
          </Typography>
        </Box>
        <Box>
          <IconButton size="small" onClick={() => props.editFun(props.data)}>
            <Box
              sx={{
                width: 15,
                height: 15,
                backgroundColor: "#757575", // Change to your desired color
                mask: `url(${CustomToolIcon}) center/contain no-repeat`,
                WebkitMask: `url(${CustomToolIcon}) center/contain no-repeat`,
                display: "inline-block",
              }}
            />
          </IconButton>
          <IconButton size="small" onClick={() => props.deleteFun(props.data)}>
            <DeleteOutlineOutlinedIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Card>
  );
};

export default ToolCard;
